<!--
  Banner Manual Sample
  Demonstrates explicit/manual usage of EzBannerService and EzBannerComponent.
-->
<ui-panel panelTitle="Banner Manual Sample">
  <ui-banner [ezConfig]="bannerConfig()"></ui-banner>

  <p class="demo-description">
    This demo uses <code>EzBannerService</code> to publish a banner message for a specific bannerId.
    Use the form to set whether the banner can be closed and provide message text/HTML.
  </p>

  <ui-form
    class="banner-form"
    [config]="bannerFormConfig"
    [containerClass]="'compact'"
    [(formValues)]="formValues"
    (buttonClick)="onFormButtonClick($event)"
  ></ui-form>
</ui-panel>
